/* eslint-disable camelcase */
import { BaseModel } from '~/shared/model'
import { isUnknownObject, isString } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { toDateAndTime } from '~/shared/utils/date'
import { ImageService } from '~/services/Misc/ImageService'

interface PositionItem {
  desired_position_id: number
  desired_position: string
}

export default class AccountResume extends BaseModel {
  id: number = 0
  'customer_id': number = 0
  'first_name': string = ''
  'middle_name': string = ''
  'last_name': string = ''
  'birth_date': string = ''
  photo: string = ''
  phone: string = ''
  email: string = ''
  position: string = ''
  'experience_beauty': string = ''
  residence: string = ''
  description: string = ''
  salary: number = 0
  'employment_type': string = ''
  'update_date': string = ''
  'desired_position': PositionItem[] = []
  'desired_position_beauty': string = ''
  'publishing_status': string = ''
  'publishing_refuse_reason': string = ''
  'publishing_refuse_reason_description': string = ''
  'publishing_statuses': string[] = []
  status: string = ''
  'status_id': string = ''

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (isString(data.update_date)) {
        this.update_date = toDateAndTime(data.update_date)
      }

      if (Array.isArray(data.desired_position) && data.desired_position.length > 0) {
        this.desired_position_beauty = data.desired_position[0].desired_position
      }

      if (data.photo && isString(data.photo)) {
        this.photo = new ImageService().cropImage(data.photo, { width: 200, height: 200 })
      }
    }
  }
}
